// extracted by mini-css-extract-plugin
export default {"noEditingBrief":"style_noEditingBrief__1NL+i","seeSample":"style_seeSample__z3tZF","icon":"style_icon__0hGOF","brief":"style_brief__eB7Yo"};